import { Category } from "@/prisma-types";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import { fetchWithAuth } from "./useAuth";

interface UseCategoryOptions {
  fetchOnMount?: boolean; // when true, fetch immediately; when false, fetch only when refetch() called
}

export function useCategory(options?: UseCategoryOptions) {
  const fetchOnMount = options?.fetchOnMount ?? true;
  const queryClient = useQueryClient();

  const query = useQuery({
    queryKey: ["categories"],
    enabled: fetchOnMount,
    queryFn: async (): Promise<Category[]> => {
      try {
        const response = await fetchWithAuth("/api/admin/categories");
        if (!response.ok) {
          throw new Error("Eroare la încărcarea categoriilor");
        }
        const result = await response.json();
        if (result && result.date && Array.isArray(result.date)) {
          return result.date as Category[];
        }
        if (result && result.data && Array.isArray(result.data)) {
          return result.data as Category[];
        }
        if (Array.isArray(result)) {
          return result as Category[];
        }
        return [] as Category[];
      } catch (error) {
        return [] as Category[];
      }
    },
  });

  const invalidate = async () => {
    await queryClient.invalidateQueries({ queryKey: ["categories"] });
  };

  return {
    categories: query.data,
    isLoading: query.isLoading,
    isFetching: query.isFetching,
    error: query.error,
    refetch: query.refetch,
    invalidate,
  };
}
